import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import NoResults from '../../assets/noresults.png'
import BlogFooter from '../../components/blog/Footer'
import Inspirations from '../../components/Feed'
import { contentIsLoading } from '../../redux/actions/InspirationFeedAction'
import { getPopularHashtags } from '../../redux/actions/PopularHashTagsAction'
import { searchByWord } from '../../redux/actions/SearchAction'
import { logEvent } from '../../utils/firebase'
import * as hashtagStyle from './search.module.css'

const Filter = require('bad-words')

const Search = props => {
  const { query } = useRouter()
  const title = query.q ? query.q : null
  const position = useSelector(state => state.scroll.position)
  const dispatch = useDispatch()
  const id = 'search'
  const filter = new Filter()
  const [metaTitle, setMetaTitle] = useState()

  useEffect(() => {
    window.scrollTo(0, position)
  }, [position, title])

  useEffect(() => {
    if (position !== 0) return

    contentIsLoading(true, 0)
    const filter = new Filter()
    if (filter.isProfane(title)) {
      return
    }
    setMetaTitle('DecorMatters Search Result-' + title)
    dispatch(searchByWord(title))
    let myStorage = window.sessionStorage
    myStorage.removeItem('currPageName')
  }, [title, dispatch, position])

  return (
    <>
      <div>
        {filter.isProfane(title) && <NoSearchResultsContainer />}

        {typeof window !== 'undefined' && !filter.isProfane(title) && (
          <Inspirations
            version="v3"
            filters={{ searchWord: title }}
            id={id}
            title={title}
            showTitle={true}
          />
        )}
      </div>
    </>
  )
}

const NoSearchResultsContainer = () => {
  return (
    <>
      <div className={hashtagStyle.noResultsContainer}>
        <PopularHashTags />
        <BlogFooter />
      </div>
    </>
  )
}

const PopularHashTags = () => {
  const popularText = 'Recommended by DecorMatters'
  const { popularHashTags } = useSelector(state => state.popularHashTags)
  const dispatch = useDispatch()

  useEffect(() => {
    if (
      popularHashTags &&
      popularHashTags.hashtags &&
      popularHashTags.hashtags.length > 0
    )
      return
    dispatch(getPopularHashtags())
  }, [popularHashTags, dispatch])

  return (
    <>
      <img src={NoResults} alt={'noresults'} />
      <p className={hashtagStyle.msg}>
        This is an invalid search term. Please try again!
      </p>
      <ul className={hashtagStyle.popularHashTagUL}>
        <li key={'PopularText'} className={hashtagStyle.popularP}>
          <p>{popularText}</p>
        </li>
        <ul key={'list-hash'}>
          {popularHashTags &&
            popularHashTags.hashtags &&
            popularHashTags.hashtags.length > 0 &&
            popularHashTags.hashtags.map((hashtag, index) => {
              if (index > 5 || hashtag.hashtagType !== 'adminPick') return false
              return (
                <li
                  className={hashtagStyle.hashtagList}
                  key={'popular_' + index}
                >
                  <Link
                    onClick={() => logEvent('invalidSearch_hashtag_clicked')}
                    role={'link'}
                    href={
                      '/search/?q=' + encodeURIComponent('#' + hashtag.title)
                    }
                  >
                    <a>
                      <p>#{hashtag.title}</p>
                      <img
                        className={hashtagStyle.hashtagImg}
                        src={hashtag.previewImageUrl}
                        onError={e =>
                          (e.target.src =
                            'didr9pubr8qfh.cloudfront.net/cfbaf6beae03cf4a47996d2ee39e9abd_Idea-Thumb.jpg')
                        }
                        alt={'hashtagimg'}
                      />
                    </a>
                  </Link>
                </li>
              )
            })}
        </ul>
      </ul>
    </>
  )
}

export default Search
